// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__2d4U6","perfil":"style_perfil__2HHm1"};